import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

export default function TrustBadge({ dark = false }) {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/public/reviews").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r?.enabled) return null;
  const full = Math.round(r.rating);
  return (
    <a data-testid="trust-badge" href={r.profile_url} target="_blank" rel="noreferrer" className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-sm ${dark ? "bg-white/10 border-white/10 text-white" : "bg-card border-border"}`}>
      <span className="flex gap-0.5">{[1, 2, 3, 4, 5].map((i) => <Star key={i} size={14} className={i <= full ? "fill-[#00b67a] text-[#00b67a]" : "text-muted-foreground/40"} />)}</span>
      <span className="font-semibold">{Number(r.rating).toFixed(1)}</span>
      <span className={dark ? "text-white/70" : "text-muted-foreground"}>{r.count ? `· ${r.count} reviews on Trustpilot` : "on Trustpilot"}</span>
    </a>
  );
}
